import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ArrowLeft, Users, BarChart3 } from "lucide-react";
import UserAnalyticsChart from "../../components/UserAnalyticsChart";

export default function UserAnalytics() {
 const navigate = useNavigate();

 return (
 <div className="min-h-screen py-6 md:py-10">
 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
 {/* Header */}
 <div className="mb-8">
 <Button
 variant="outline"
 onClick={() => navigate("/admin/dashboard")}
 className="mb-6"
 >
 <ArrowLeft className="w-4 h-4 mr-2" />
 Back to Dashboard
 </Button>

 <div className="flex items-center gap-3 mb-2">
 <div className="p-2.5 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-600 shadow-lg">
 <Users className="w-6 h-6 text-white" />
 </div>
 <h1 className="text-3xl md:text-4xl font-bold">User Analytics</h1>
 </div>
 <p className="text-muted-foreground">
 Track user growth and activity patterns
 </p>
 </div>

 {/* Chart */}
 <UserAnalyticsChart />
 </div>
 </div>
 );
}
